<template>
  <fragment>
    <v-dialog
      v-model="$ticketPackage.addPackage"
      class="rounded-lg"
      persistent
      :max-width="dialogWidth"
      max-height="800"
      min-height="800"
      scrollable
    >
      <v-card class="base rounded-lg" tile>
        <v-card-title
          flat
          dark
          rounded
          color="base"
          class="text-subtitle-1 text-sm-h6"
        >
          {{ titleModal }}
          <v-spacer></v-spacer>
          <v-btn class="mt-0 mr-0" dark icon @click="closeModal">
            <CloseIcon />
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <PackageForm v-if="firstStep" />
            <Loader v-if="secondStep" type="linear" :size="10" />
            <SendPackageForm v-if="thirdStep" />
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4 pr-6">
          <v-spacer></v-spacer>
          <template v-if="isTypePackageNew">
            <v-btn
              class="rounded-lg"
              color="transparent"
              elevation="0"
              @click="closeModal()"
              >{{ $t('sales.ticket_cancel') }}</v-btn
            >
            <v-btn class="rounded-lg" dark dense @click="registerValidate()"
              >{{ $t('sales.ticket_save') }}</v-btn
            >
          </template>
          <template v-else>
            <v-btn
              class="rounded-lg"
              color="transparent"
              elevation="0"
              @click="closeModal()"
              >{{ $t('sales.ticket_cancel') }}</v-btn
            >
            <v-btn
              class="rounded-lg"
              dark
              dense
              :loading="$ticketPackage.saveLoading"
              @click="$ticketPackage.savePackage()"
              >{{ $t('sales.ticket_save') }}</v-btn
            >
            <v-btn
              class="rounded-lg"
              dark
              dense
              :loading="$ticketPackage.sendLoading"
              @click="() => $ticketPackage.saveAndSendPackage()"
              >{{ $t('sales.ticket_save_send') }}</v-btn
            >
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PackageProductModal @generate="packageGenerate($event)" />
    <ModalConfirmacao
      :textModal="$ticketPackage.text"
      @callback="$ticketPackage.productFromPackageDelete"
    />
  </fragment>
</template>

<script>
import PackageProductModal from "@/components/vendas/PackageProductModal.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";
import PackageForm from "@/components/vendas/PackageForm.vue";
import SendPackageForm from "@/components/vendas/SendPackageForm.vue";
import Loader from "@/components/global/Loader.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";
export default {
  name: "ModalPacoteIngresso",
  components: {
    PackageProductModal,
    ModalConfirmacao,
    PackageForm,
    SendPackageForm,
    Loader,
    CloseIcon,
  },
  watch: {
    "$ticketPackage.cadastro.loja"(e) {
      if (e === null || e === undefined || e === "") {
        this.disableConsumidor = true;
        return;
      } else {
        this.disableConsumidor = false;
        this.$loja_consumidor.getConsumidor(e);
      }
    },
    "$ticketPackage.cadastro.consumidor": function (consumidor) {
      let consumerHasAReservedPackage =
        this.$ticketPackage.pacotes_ingressos.findIndex(
          item => item.idconsumidor === consumidor && item.status === "RE"
        );

      if (
        consumerHasAReservedPackage !== -1 &&
        this.$ticketPackage.type === "new"
      ) {
        this.$config.alert(
          "Já existe um pacote de ingresso reservado para este consumidor!",
          this.$config.dados.alertColor
        );
        return;
      }
    },
  },
  computed: {
    titleModal() {
      switch (this.$ticketPackage.type) {
        case "new":
          return this.$t('sales.ticket_new_title');
        case "edit":
          return this.$t('sales.ticket_edit_title');
        case "send":
          return this.$t('sales.ticket_modal_title');
        default:
          return this.$t('sales.ticket_new_title');
      }
    },
    hasProductsInThePackage() {
      return this.$ticketPackage.cadastro.itens.length > 0;
    },
    firstStep() {
      return this.$ticketPackage.packageProductStep === 1;
    },
    secondStep() {
      return this.$ticketPackage.packageProductStep === 2;
    },
    thirdStep() {
      return this.$ticketPackage.packageProductStep === 3;
    },
    dialogWidth() {
      return this.thirdStep ? "1100" : "900";
    },
    isTypePackageNew() {
      return (
        this.$ticketPackage.type === "new" ||
        this.$ticketPackage.type === "edit"
      );
    },
  },
  methods: {
    registerValidate() {
      if (this.$refs.form.validate()) {
        this.$ticketPackage.cadastro.cortesia = 1;
        this.$ticketPackage.reservedPackageContentPreview?.map(item => {
          if (item.tipo !== "CORTESIA") {
            if (item.quantityPossibilities.length === 0) {
              this.$ticketPackage.cadastro.cortesia = 0;
            } else {
              item.quantityPossibilities.map(vari => {
                if (vari.quantity > 0 && vari.taxa !== "CORTESIA") {
                  this.$ticketPackage.cadastro.cortesia = 0;
                }
              });
            }
          }
        });
        this.$ticketPackage.registerValidate();
      }
    },
    closeModal() {
      this.$ticketPackage.addPackage = false;
      this.$ticketPackage.clearModalPacoteIngresso("cadastro");
      this.$ticketPackage.sendPackageInfo = [];
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    packageGenerate(product) {
      const { itens } = product;
      this.$ticketPackage.cadastro.itens = [
        ...this.$ticketPackage.cadastro.itens,
        ...itens,
      ];

      this.reservedPackagePreviewGenerate(product);
    },
    reservedPackagePreviewGenerate(product) {
      const { productInCart } = product;

      const packageContentPreviewIndex =
        this.$ticketPackage.reservedPackageContentPreview.findIndex(
          item => item.idproduto === productInCart.idproduto
        );

      if (packageContentPreviewIndex === -1) {
        this.$ticketPackage.reservedPackageContentPreview.push(productInCart);
      } else {
        this.$ticketPackage.reservedPackageContentPreview.splice(
          packageContentPreviewIndex,
          1,
          productInCart
        );
      }
    },
    generateLink() {
      this.$ticketPackage.gerarLinkCarrinho(this.packageContent);
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
  cursor: pointer;
}
</style>
